import { createTheme } from '@mui/material/styles';

export const whitelabelTheme = createTheme({
    typography: {
        fontFamily: 'Inter, sans-serif',
        h1: {
            fontSize: '1.9em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h2: {
            fontSize: '1.4em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h3: {
            fontSize: '1.2em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h4: {
            fontSize: '1em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h5: {
            fontSize: '1.2em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        h6: {
            fontSize: '1.2em',
            fontWeight: 700,
            textAlign: 'left',
            fontFamily: 'Sora, sans-serif',
        },
        subtitle2: {
            fontSize: '0.9rem',
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
        },
    },
    spacing: 10,
    palette: {
        background: {
            default: '#fafafa',
        },
        primary: {
            main: '#105c9d',
        },
        secondary: {
            main: '#64AFA4',
        },
        brand: {
            main: '#F9C7B3',
        },
        calm: {
            dark: '#376C60',
            main: '#478A7E',
            light: '#DBECEA',
        },
        focus: {
            dark: '#E84F30',
            main: '#EC6F57',
            light: '#F4AD9F',
        },
        extra: {
            dark: '#20476F',
            main: '#3876B7',
            light: '#6B9CD1',
        },
        ai: {
            dark: '#441c5e',
            main: '#ca67f5',
            light: '#efe1f5',
        },
        success: {
            main: '#268320',
        },
        error: {
            main: '#D62400',
        },
        divider: '#bbb',
    },
    shape: {
        borderRadius: 2,
    },
    components: {
        MuiAppBar: {
            defaultProps: {
                style: {
                    backgroundColor: '#000',
                    color: '#fff',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontSize: '0.9rem',
                    fontWeight: 600,
                },
            },
        },
        MuiDialogActions: {
            defaultProps: {
                style: {
                    padding: 20,
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                color: 'primary',
                style: {
                    backgroundColor: '#fff',
                },
                size: 'small',
            },
        },
        MuiSelect: {
            defaultProps: {
                color: 'primary',
                style: {
                    backgroundColor: '#fff',
                },
                size: 'small',
            },
        },
        MuiFormControl: {
            defaultProps: {
                color: 'primary',
                size: 'small',
            },
        },
        MuiButton: {
            defaultProps: {
                style: {
                    boxShadow: 'none',
                },
                size: 'medium',
            },
        },
    },
});
